/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Your_PlanInputs */

const en_plan_your_plan = /** @type {(inputs: Plan_Your_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan`)
};

const es_plan_your_plan = /** @type {(inputs: Plan_Your_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan`)
};

/**
* | output |
* | --- |
* | "Your plan" |
*
* @param {Plan_Your_PlanInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_your_plan = /** @type {((inputs?: Plan_Your_PlanInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Your_PlanInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_your_plan(inputs)
	return en_plan_your_plan(inputs)
});